const knownVenueStateChipConfigs = {
  live: {
    label: 'Live',
    color: '#DCFCE7',
    background: 'rgba(34, 197, 94, 0.18)',
    borderColor: 'rgba(74, 222, 128, 0.36)'
  },
  active: {
    label: 'Live',
    color: '#DCFCE7',
    background: 'rgba(34, 197, 94, 0.18)',
    borderColor: 'rgba(74, 222, 128, 0.36)'
  },
  canceled: {
    label: 'Canceled',
    color: '#FECACA',
    background: 'rgba(239, 68, 68, 0.16)',
    borderColor: 'rgba(248, 113, 113, 0.3)'
  },
  closed: {
    label: 'Closed',
    color: '#FDE68A',
    background: 'rgba(245, 158, 11, 0.16)',
    borderColor: 'rgba(251, 191, 36, 0.28)'
  },
  review: {
    label: 'Review',
    color: '#BFDBFE',
    background: 'rgba(59, 130, 246, 0.16)',
    borderColor: 'rgba(96, 165, 250, 0.3)'
  },
  reward: {
    label: 'Reward',
    color: '#FDE68A',
    background: 'rgba(234, 179, 8, 0.16)',
    borderColor: 'rgba(250, 204, 21, 0.3)'
  },
  concluded: {
    label: 'Concluded',
    color: '#DDD6FE',
    background: 'rgba(139, 92, 246, 0.16)',
    borderColor: 'rgba(167, 139, 250, 0.3)'
  },
  created: {
    label: 'Created',
    color: '#E2E8F0',
    background: 'rgba(148, 163, 184, 0.18)',
    borderColor: 'rgba(148, 163, 184, 0.28)'
  }
}

const unknownVenueStateChipConfig = (state) => ({
  label: state || 'Unknown',
  color: '#E2E8F0',
  background: 'rgba(100, 116, 139, 0.16)',
  borderColor: 'rgba(148, 163, 184, 0.24)'
})

export const venueStateChipConfig = (state, { includeUnknown = true } = {}) => {
  const normalizedState = String(state || '').trim().toLowerCase()
  const knownConfig = knownVenueStateChipConfigs[normalizedState]
  if (knownConfig) return knownConfig
  return includeUnknown ? unknownVenueStateChipConfig(normalizedState) : null
}

export default venueStateChipConfig
